var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1619 7.21432L5.74328 16.1394C5.29169 16.6178 4.726 16.9571 4.10663 17.1212L0.877038 17.9774C0.758799 18.0089 0.634854 18.0075 0.517315 17.9731C0.399777 17.9387 0.292664 17.8726 0.206444 17.7812C0.120224 17.6898 0.0578456 17.5762 0.0254044 17.4517C-0.00703688 17.3271 -0.00843132 17.1957 0.0213571 17.0704L0.829108 13.6485C0.984055 12.9913 1.30469 12.3911 1.75668 11.9122L10.1739 2.9871L14.1619 7.21432ZM16.1566 0.875736C16.6852 1.43616 16.9821 2.19616 16.9821 2.9886C16.9821 3.78104 16.6852 4.54103 16.1566 5.10146L15.1586 6.1564L11.1706 1.93067L12.1686 0.875736C12.4305 0.598101 12.7413 0.377862 13.0834 0.227601C13.4256 0.0773397 13.7923 0 14.1626 0C14.533 0 14.8997 0.0773397 15.2418 0.227601C15.584 0.377862 15.8948 0.598101 16.1566 0.875736Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.13be420c.svg";
export { ForwardRef as ReactComponent };